'use client';
import { useEffect } from 'react';
import {
  getLocalStorageVisitorToken,
  setLocalStorageVisitorToken,
} from '@mentimeter/visitor/visitor-token';
import {
  getCountryFromLocalStorage,
  setVisitorDataCache,
} from '@mentimeter/visitor/visitor-data';
import { LocalStorage } from '@mentimeter/storage';
import Cookies from '@mentimeter/cookies';
import { USER_LOCALE_STORAGE_KEY } from '@mentimeter/i18n-core';

export default function SetupLocalStorageAndCookies({
  visitorToken,
  locale,
  country,
}: {
  visitorToken: string;
  locale: string;
  country: string | null;
}) {
  const localStorageVisitorToken = getLocalStorageVisitorToken();
  // we want to ensure that we don't re-render the page if we don't have a token in localStorage
  // so let's set it and use the one coming from the server as a fallback
  if (!localStorageVisitorToken) {
    setLocalStorageVisitorToken(visitorToken);
  }

  useMigrateLocalStorageLocaleToCookie();

  if (getCountryFromLocalStorage() === null) {
    setVisitorDataCache({
      country: country ?? 'none',
    });
  }

  return null;
}

// When we removed the use of locale in LocalStorage this is not needed.
function useMigrateLocalStorageLocaleToCookie() {
  useEffect(() => {
    const localStorageLocale = LocalStorage.getItem(USER_LOCALE_STORAGE_KEY);
    const cookieLocale = Cookies.get(USER_LOCALE_STORAGE_KEY);
    if (localStorageLocale && !cookieLocale) {
      Cookies.set({
        type: 'functional',
        name: USER_LOCALE_STORAGE_KEY,
        value: localStorageLocale,
        options: {
          expires: 365,
          secure: true,
          sameSite: 'lax',
        },
      });
      window.location.reload();
    }
  }, []);
}
